import { Outlet } from "react-router-dom";

export default function PageContent() {
    return(       
        <>
            <Outlet />
        </>
    )
}